<!-- eslint-disable -->
<template>
  <div class="tab-container-full">
    <!-- 기관 구분 탭 (Main Tabs) -->
    <div class="tab-head">
      <div class="tab-menu-wrap box-type">
        <button
            v-for="org in orgSelections"
            :key="org.id"
            type="button"
            class="font-body-style3 tab-menu"
            :class="{
            'is-active': activeOrg === org.id,
            'center-filter': org.id === 'center',
            'center-selecting': org.id === 'center' && showCenterFilter && activeOrg !== 'center'
          }"
            @click="selectOrg(org.id)"
            :data-tab="`tab1-con${org.index}`"
            aria-label="tab메뉴" title="tab메뉴">
          <span v-html="org.displayLabel"></span>
        </button>
      </div>

      <!-- 센터 필터 리스트 -->
      <div
          v-if="showCenterFilter"
          class="center-filter-list"
          id="centerFilterList"
      >
        <!-- PC 뷰 버전 -->
        <div class="pc-view">
          <ul class="center-filter-list-inner">
            <li v-for="center in centerList" :key="center.id">
              <button
                  class="btn btn-xsm btn-secondary"
                  :class="{ 'on': activeCenter === center.id }"
                  type="button"
                  @click="selectCenter(center.id)"
                  aria-label="filter 메뉴" title="filter 메뉴">
                {{ center.label }}
              </button>
            </li>
            <li>
              <button
                  type="button"
                  class="btn btn-close only-icon close-modal"
                  aria-label="닫기"
                  @click="closeCenterFilter" title="닫기">
                <i class="ico ico-x-bl"></i>
              </button>
            </li>
          </ul>
        </div>

        <!-- 모바일 뷰 버전 -->
        <div class="mo-view">
          <div class="center-filter-top">
            <strong class="h4-title">센터</strong>
            <button
                type="button"
                class="btn btn-close only-icon close-modal"
                @click="closeCenterFilter"
                aria-label="닫기 버튼" title="닫기 버튼">
              <i class="ico ico-x-bl"></i>
            </button>
          </div>
          <ul class="center-filter-list-inner">
            <li v-for="center in centerList" :key="center.id">
              <button
                  class="btn"
                  :class="{ 'on': activeCenter === center.id }"
                  type="button"
                  @click="selectCenter(center.id)"
                  aria-label="필터 버튼" title="필터 버튼">
                {{ center.label }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 메뉴 구분 탭 및 컨텐츠 (Sub Tabs) -->
    <div class="tab-content__wrap box-line">
      <!-- 각 기관별 탭 컨텐츠 -->
      <div
          v-for="org in orgSelections"
          :key="org.id"
          class="tab-content flex-direction"
          :class="{ 'is-active': activeOrg === org.id }"
          :id="`tab1-con${org.index}`"
      >
        <div class="tab-container-sort">
          <!-- 메뉴 구분 서브 탭 -->
          <div class="tab-menu-wrap scroll-tab">
            <button
                v-for="menu in org.menuItems"
                :key="menu.id"
                type="button"
                class="font-body-style3 tab-menu"
                :class="{ 'is-active': activeMenu === menu.id }"
                @click="selectMenu(menu.id)"
                aria-label="탭메뉴 버튼" title="탭메뉴 버튼">
              {{ menu.label }}
              <span class="result-count">{{ formatCount(menu.count) }}건</span>
            </button>
          </div>

          <!-- 검색 조건 UI -->
          <div class="form-section mt-32">
            <ul class="sort-wrap">
              <li>
                <div class="activity-item">
                  <span class="th-name">순서</span>
                  <div class="input-area">
                    <select
                        title="정렬 기준 선택"
                        v-model="searchFilters.sort"
                        @change="onFilterChange"
                    >
                      <option value="RANK">정확도순</option>
                      <option value="DATE">최신순</option>
                    </select>
                  </div>
                </div>
              </li>
              <li>
                <div class="activity-item">
                  <span class="th-name">기간</span>
                  <div class="input-area">
                    <select
                        title="기간 선택"
                        v-model="searchFilters.period"
                        @change="onFilterChange"
                    >
                      <option value="ALL">전체 기간</option>
                      <option value="today">오늘</option>
                      <option value="1month">1개월</option>
                      <option value="1year">1년</option>
                    </select>
                  </div>
                </div>
              </li>
              <li>
                <div class="activity-item">
                  <span class="th-name">기준</span>
                  <div class="input-area">
                    <select
                        title="검색 범위 선택"
                        v-model="searchFilters.field"
                        @change="onFilterChange"
                    >
                      <option value="ALL">전체 범위</option>
                      <option value="TITLE">제목</option>
                      <option value="CONTENT">내용</option>
                    </select>
                  </div>
                </div>
              </li>
              <!-- 표시 수 필터는 전체 탭에서만 표시 -->
              <li v-if="activeMenu === 'ALL'">
                <div class="activity-item">
                  <span class="th-name">표시</span>
                  <div class="input-area">
                    <select
                        title="표시 개수 선택"
                        v-model="searchFilters.display"
                        @change="onFilterChange"
                    >
                      <option value="3">3개씩</option>
                      <option value="10">10개씩</option>
                      <option value="30">30개씩</option>
                    </select>
                  </div>
                </div>
              </li>
              <li>
                <button
                    type="button"
                    class="btn btn-primary btn-form-size"
                    @click="handleFilterSearch"
                >
                  검색
                </button>
              </li>
            </ul>
          </div>

          <!-- 검색 결과 영역 -->
          <div class="tab-content mt-24 sort-type" v-if="hasSearched">
            <!-- SearchResults의 내용을 여기에 직접 렌더링 -->
            <div
                v-for="category in displayCategories"
                :key="category.key"
                class="result-category"
            >
              <div class="article-result" :class="{ 'no-result': category.items.length === 0 }">
                {{ category.title }}
                <span class="result-keyword">({{ category.count }})</span>
              </div>
              <div v-if="category.items.length === 0">검색 결과가 없습니다.</div>

              <ul class="article-list" v-if="category.items.length > 0">
                <li
                    v-for="item in category.items"
                    :key="item.id"
                    class="article-item"
                >
                  <a :href="item.linkUrl" class="article-link" aria-label="본문 바로가기" title="본문 바로가기">
                    <div v-if="item.imageUrl && !item.imageError" class="article-thumbnail article-image-container">
                      <img
                          :src="item.imageUrl"
                          class="article-image"
                          @error="handleImageError(item)"
                          @load="handleImageLoad(item)" alt="">
                    </div>
                    <div
                        v-else
                        class="article-thumbnail"
                    >
                      <div class="article-image-placeholder"></div>
                    </div>
                    <div class="article-details">
                      <time
                          class="article-date"
                          :datetime="item.date"
                      >
                        {{ formatDate(item.date) }}
                      </time>
                      <h5
                          class="article-title"
                          v-html="highlightKeyword(item.title)"
                      ></h5>
                      <p
                          class="article-description"
                          v-html="highlightKeyword(item.description)"
                      ></p>
                      <div class="article-bottom">
                        <div class="article-keywords">
                          <span>연관 키워드 </span>
                          <span
                              v-for="tag in item.tags"
                              :key="tag"
                              class="article-tag"
                              @click.stop.prevent="searchByTag(tag)"
                              style="cursor: pointer;"
                          >
                            #{{ tag }}
                          </span>
                        </div>
                        <div class="color-gray">
                          {{ item.organization }} : {{ formatTimestamp(item.timestamp) }}
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>

              <!-- 더보기 버튼 -->
              <div
                  v-if="category.hasMore"
                  class="button-area btn-load-more"
              >
                <button
                    type="button"
                    @click="loadMoreCategory(category.key)"
                >
                  <i class="ico ico-plus"></i>
                  더보기
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- 페이지네이션 (개별 탭에서만 표시) -->
      <nav
          v-if="activeMenu !== 'ALL' && hasSearched && currentResults.totalCount > 0"
          class="pagination-container"
      >
        <ul class="pagination">
          <li class="page-item" :class="{ disabled: currentPage <= 1 }">
            <a class="page-link btn-page" href="#" @click.prevent="goToPage(1)" title="« 입력">«</a>
          </li>
          <li class="page-item" :class="{ disabled: currentPage <= 1 }">
            <a class="page-link btn-page" href="#" @click.prevent="goToPage(currentPage - 1)" title="‹ 입력">‹</a>
          </li>

          <li
              v-for="page in visiblePages"
              :key="page"
              class="page-item"
              :class="{
                active: page === currentPage,
                'pc-only': shouldHideOnMobile(page)
              }"
          >
            <a class="page-link" href="#" @click.prevent="goToPage(page)" title="{{ page }} 페이지">{{ page }}</a>
          </li>

          <li class="page-item" :class="{ disabled: currentPage >= totalPages }">
            <a class="page-link btn-page" href="#" @click.prevent="goToPage(currentPage + 1)" title="› 입력">›</a>
          </li>
          <li class="page-item" :class="{ disabled: currentPage >= totalPages }">
            <a class="page-link btn-page" href="#" @click.prevent="goToPage(totalPages)" title="» 입력">»</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchContent',
  props: {
    searchQuery: {
      type: String,
      required: true
    },
    searchResults: {
      type: Object,
      default: () => ({})
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    hasSearched: {
      type: Boolean,
      default: false
    },
    centerOrgsData: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      // 기관 구분 (Main Tabs)
      activeOrg: 'job-info',
      orgSelections: [
        {
          id: 'job-info',
          label: '일자리정보몽땅',
          displayLabel: '일자리<br class="mo-only">정보몽땅',
          index: 1,
          menuItems: [
            {id: 'ALL', label: '전체', count: 0},
            {id: 'job_work', label: '일자리', count: 0},
            {id: 'job_edu', label: '역량강화', count: 0},
            {id: 'job_senior', label: '시니어전용', count: 0},
            {id: 'job_company', label: '기업지원', count: 0},
            {id: 'job_business', label: '사업안내', count: 0}
          ]
        },
        {
          id: 'foundation',
          label: '재단',
          displayLabel: '재단',
          index: 2,
          menuItems: [
            {id: 'ALL', label: '전체', count: 0},
            {id: 'fou_news', label: '소식', count: 0},
            {id: 'fou_edu', label: '배움', count: 0},
            {id: 'fou_info', label: '지식정보', count: 0},
            {id: 'fou_community', label: '커뮤니티', count: 0},
            {id: 'fou_open', label: '정보공개', count: 0}
          ]
        },
        {
          id: 'senior-info',
          label: '라이프몽땅',
          displayLabel: '라이프<br class="mo-only">몽땅',
          index: 3,
          menuItems: [
            {id: 'ALL', label: '전체', count: 0},
            {id: 'por_news', label: '50플러스소식', count: 0},
            {id: 'por_edu', label: '역량개발', count: 0},
            {id: 'por_work', label: '취업지원', count: 0},
            {id: 'por_community', label: '기업지원', count: 0},
            {id: 'por_life', label: '라이프몽땅', count: 0},
            {id: 'por_counsel', label: '경력설계', count: 0}
          ]
        },
        {
          id: 'center',
          label: '센터',
          displayLabel: '센터',
          index: 4,
          menuItems: [
            {id: 'ALL', label: '전체', count: 0},
            {id: 'cen_news', label: '소식', count: 0},
            {id: 'cen_edu', label: '배움', count: 0},
            {id: 'cen_work', label: '일참여', count: 0},
            {id: 'cen_community', label: '커뮤니티', count: 0},
            {id: 'cen_business', label: '사업안내', count: 0}
          ]
        }
      ],

      // 메뉴 구분 (Sub Tabs)
      activeMenu: 'ALL',

      // 센터 필터
      activeCenter: '',
      showCenterFilter: false,

      // 검색 조건
      searchFilters: {
        sort: 'RANK',
        period: 'ALL',
        field: 'ALL',
        display: '3'
      },

      // 페이지네이션
      currentPage: 1,
      totalPages: 1,

      // 센터 필터 관련
      previousActiveOrg: 'job-info'
    };
  },
  computed: {
    // 동적 센터 리스트 생성
    centerList() {
      if (this.centerOrgsData && this.centerOrgsData.length > 0) {
        return this.centerOrgsData.map(org => ({
          id: org.id,
          label: org.label
        }));
      }
    },

    currentOrg() {
      return this.orgSelections.find(org => org.id === this.activeOrg) || this.orgSelections[0];
    },

    currentMenuLabel() {
      const menu = this.currentOrg.menuItems.find(item => item.id === this.activeMenu);
      return menu ? menu.label : '';
    },

    displayCategories() {

      if (!this.searchResults || !this.searchResults.colResultList) {
        return [];
      }

      // activeMenu이 'ALL'이면 모든 결과, 그렇지 않으면 해당 컬렉션만
      const filteredCollections = this.activeMenu === 'ALL'
          ? this.searchResults.colResultList
          : this.searchResults.colResultList.filter(collection =>
              collection.thisCollection === this.activeMenu
          );


      const result = filteredCollections.map(collection => ({
        key: collection.thisCollection,
        title: collection.thisCollectionKorName,
        count: collection.thisTotalCount || 0,
        items: (collection.colDetailList || []).map(item => ({
          id: item.DOCID || item.ANN_NO || '',
          title: item.TITLE || '',
          description: this.decodeSearchContentSafe(item.CONTENT || ''),
          date: this.formatDate(item.CUR_DATE || ''),
          organization: item.ORG_NM || '',
          tags: this.extractTags(item),
          linkUrl: this.generateUrl(item),
          imageUrl: item.IMG_URL || null,
          imageError: false, // 초기값 설정
          timestamp: item.CUR_DATE || ''
        })),
        // 전체 탭에서는 결과가 있으면 더보기(탭 전환) 버튼 표시
        hasMore: this.activeMenu === 'ALL' && (collection.thisTotalCount || 0) > 0
      }));


      return result;
    },

    currentResults() {
      if (!this.searchResults || !this.searchResults.colResultList) {
        return {items: [], totalCount: 0};
      }

      // 전체 탭인 경우 모든 컬렉션의 결과를 합쳐서 표시
      if (this.activeMenu === 'ALL') {
        const allItems = [];
        let totalCount = 0;

        this.searchResults.colResultList.forEach(collection => {
          if (collection.colDetailList && collection.colDetailList.length > 0) {
            const items = collection.colDetailList.map(item => ({
              id: item.DOCID || item.ANN_NO || '',
              title: item.TITLE || '',
              description: item.CONTENT ? this.decodeSearchContentSafe(item.CONTENT) : '',
              date: item.DATE || item.CUR_DATE || '',
              centerName: item.ORG_NM || '',
              tags: item.TAGS_NM ? item.TAGS_NM.split(',') : [],
              imageUrl: item.IMG_URL || null,
              imageError: false // 초기값 설정
            }));
            allItems.push(...items);
            totalCount += collection.thisTotalCount || 0;
          }
        });

        return {items: allItems, totalCount};
      } else {
        // 개별 메뉴 탭인 경우 해당 컬렉션의 결과만 표시
        const collection = this.searchResults.colResultList.find(col =>
            col.thisCollection === this.activeMenu
        );

        if (!collection || !collection.colDetailList) {
          return {items: [], totalCount: 0};
        }

        const items = collection.colDetailList.map(item => ({
          id: item.DOCID || item.ANN_NO || '',
          title: item.TITLE || '',
          description: item.CONTENT ? this.decodeSearchContentSafe(item.CONTENT) : '',
          date: item.DATE || item.CUR_DATE || '',
          centerName: item.ORG_NM || '',
          tags: item.TAGS_NM ? item.TAGS_NM.split(',') : [],
          imageUrl: item.IMG_URL || null,
          imageError: false // 초기값 설정
        }));

        return {
          items,
          totalCount: collection.thisTotalCount || 0
        };
      }
    },

    visiblePages() {
      const pages = [];
      const start = Math.max(1, this.currentPage - 4);
      const end = Math.min(this.totalPages, this.currentPage + 5);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    }
  },
  methods: {
    // 기관 탭 선택
    selectOrg(orgId) {
      // 센터 탭 클릭시 특별 처리: 바로 활성화하지 않고 필터 목록만 표시
      if (orgId === 'center') {
        if (!this.showCenterFilter) {
          this.previousActiveOrg = this.activeOrg; // 현재 활성 탭 저장
          this.showCenterFilter = true;
        } else {
          // 이미 필터가 표시된 상태에서 센터 탭을 다시 클릭하면 필터를 닫음
          this.closeCenterFilter();
        }
        return; // 여기서 리턴하여 실제 탭 변경은 하지 않음
      }

      if (this.activeOrg === orgId) return;

      // 다른 탭 선택시 센터 필터 숨김 및 센터 선택 초기화
      this.showCenterFilter = false;
      this.activeCenter = ''; // 센터 선택 초기화
      this.activeOrg = orgId;
      this.activeMenu = 'ALL'; // 기관 변경 시 전체 탭으로 리셋
      this.currentPage = 1;

      // 부모 컴포넌트에 탭 변경 알림
      this.emitTabChange();
    },

    // 메뉴 탭 선택
    selectMenu(menuId) {
      if (this.activeMenu === menuId) return;

      this.activeMenu = menuId;
      this.currentPage = 1;

      // 부모 컴포넌트에 탭 변경 알림
      this.emitTabChange();
    },

    // 센터 선택
    selectCenter(centerId) {
      if (this.activeCenter === centerId) {
        // 이미 선택된 센터를 다시 클릭하면 필터를 닫음
        this.showCenterFilter = false;
        return;
      }

      this.activeCenter = centerId;
      this.activeOrg = 'center'; // 센터 탭 활성화
      this.activeMenu = 'ALL'; // 전체 메뉴로 리셋
      this.currentPage = 1;
      this.showCenterFilter = false; // 필터 목록 숨김

      // 부모 컴포넌트에 탭 변경 알림 (검색 API 호출)
      this.emitTabChange();
    },

    // 센터 필터 닫기
    closeCenterFilter() {
      this.showCenterFilter = false;
      this.activeCenter = ''; // 센터 선택 초기화
    },

    // 검색 조건 변경
    onFilterChange() {
      // 필터 변경시에는 자동 검색 안함 (명시적으로 검색 버튼 클릭해야 함)
    },

    // 필터 검색 실행
    handleFilterSearch() {
      this.currentPage = 1;
      this.emitTabChange();
    },

    // 부모 컴포넌트에 탭 변경 알림
    emitTabChange() {
      // 개별 탭에서는 항상 10개씩, 전체 탭에서는 사용자 선택값 사용
      const displayCount = this.activeMenu === 'ALL' ? this.searchFilters.display : '10';

      const searchParams = {
        query: this.searchQuery,
        orgType: this.activeOrg,
        menuType: this.activeMenu,
        centerType: this.activeCenter,
        filters: {
          ...this.searchFilters,
          startCount: (this.currentPage - 1) * parseInt(displayCount),
          searchSel: displayCount
        }
      };

      this.$emit('tab-change', {searchParams});
    },

    // 카테고리별 더보기 -> 해당 메뉴 탭으로 전환
    loadMoreCategory(categoryKey) {
      // 카테고리 키를 실제 메뉴 ID로 매핑
      const categoryMenuMap = {
        'job': 'job_work',
        'education': 'job_edu',
        'senior-center': 'job_senior',
        'company': 'job_company',
        'business': 'job_business'
      };

      const menuId = categoryMenuMap[categoryKey] || categoryKey;

      // 해당 메뉴 탭으로 전환
      this.selectMenu(menuId);

      // 상단으로 스크롤 이동 (탭 전환 후)
      this.$nextTick(() => {
        this.scrollToTop();
      });
    },

    // 상단으로 스크롤 이동
    scrollToTop() {
      // 검색 영역 또는 페이지 상단으로 스크롤
      const searchContainer = document.querySelector('#unified-search-app') ||
          document.querySelector('.search-wrap') ||
          document.querySelector('.page-title-wrap');

      if (searchContainer) {
        searchContainer.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        // 포커스도 함께 이동 (접근성)
        const searchInput = searchContainer.querySelector('input[type="text"]');
        if (searchInput) {
          searchInput.focus();
        }
      } else {
        // 기본 상단 스크롤
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }

    },

    // 검색 결과 카운트 업데이트
    updateSearchCounts: function (searchResults) {

      if (!searchResults || !searchResults.colCountListAll) {
        return;
      }

      const colCountListAll = searchResults.colCountListAll;

      // 현재 활성 기관의 메뉴 아이템만 업데이트 (다른 기관은 업데이트하지 않음)
      const currentOrg = this.orgSelections.find(org => org.id === this.activeOrg);
      if (!currentOrg) {
        return;
      }

      // 전체 탭의 총 카운트 계산
      let totalCount = 0;
      Object.values(colCountListAll).forEach(count => {
        totalCount += count;
      });


      currentOrg.menuItems.forEach(menu => {
        let count = 0;

        if (menu.id === 'ALL') {
          // 전체 탭의 경우 모든 컬렉션의 합계 사용
          count = totalCount;
        } else {
          // 개별 메뉴의 경우 colCountListAll에서 직접 조회
          count = colCountListAll[menu.id] || 0;
        }

        menu.count = count;
      });

      // 페이지네이션 정보 업데이트
      this.updatePaginationInfo(searchResults);
    },

    // 페이지네이션 정보 업데이트
    updatePaginationInfo(searchResults) {
      if (!searchResults || !searchResults.colResultList) {
        this.totalPages = 1;
        return;
      }

      // 현재 활성 메뉴에 해당하는 컬렉션 찾기
      let currentCollection = null;

      if (this.activeMenu === 'ALL') {
        // 전체 탭의 경우: 전체 건수와 현재 표시 수로 계산
        const totalCount = searchResults.totalCount || 0;
        const displayCount = parseInt(this.searchFilters.display) || 10;
        this.totalPages = Math.ceil(totalCount / displayCount);

        return;
      }

      // 개별 탭의 경우: 해당 컬렉션의 thisTotalCount 사용
      currentCollection = searchResults.colResultList.find(collection =>
          collection.thisCollection === this.activeMenu
      );

      if (currentCollection) {
        const totalCount = currentCollection.thisTotalCount || 0;
        const displayCount = 10; // 개별 탭은 항상 10개씩
        this.totalPages = Math.ceil(totalCount / displayCount);

      } else {
        this.totalPages = 1;
      }
    },

    // HTML 태그 제거
    // 다중 인코딩된 콘텐츠를 안전하게 디코딩하는 함수
    decodeSearchContentSafe: function (content) {
      if (!content) return '';

      try {
        // 1단계: 유니코드 디코딩
        let decoded = content.replace(/\\u[\dA-F]{4}/gi, (match) =>
            String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16))
        );

        // 2단계: DOM을 이용한 HTML 엔티티 디코딩
        const textarea = document.createElement('textarea');
        textarea.innerHTML = decoded;
        decoded = textarea.value;

        // 3단계: HTML 태그 제거
        return decoded.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
      } catch (error) {
        // 디코딩 실패시 원본 반환
        return content;
      }
    },

    stripHtml: function (html) {
      if (!html) return '';
      return html.replace(/<[^>]*>/g, '').replace(/&[^;]+;/g, ' ').trim();
    },

    // 페이지 이동
    goToPage: function (page) {
      if (page < 1 || page > this.totalPages || page === this.currentPage) {
        return;
      }

      this.currentPage = page;
      this.emitTabChange();

      // 페이지 변경 후 상단으로 스크롤 이동
      this.$nextTick(() => {
        this.scrollToTop();
      });
    },

    // 모바일에서 숨길 페이지 번호 결정
    shouldHideOnMobile: function (page) {
      // 모바일에서는 현재 페이지 주변 5개만 표시
      return Math.abs(page - this.currentPage) > 2;
    },

    // 숫자 포맷팅
    formatCount(count) {
      return count >= 10000 ? `${Math.floor(count / 1000)},000` : count.toLocaleString();
    },


    // SearchResults 메서드들 추가
    highlightKeyword(text) {
      if (!this.searchQuery || !text) {
        return text;
      }

      const keyword = this.searchQuery.trim();
      if (!keyword) {
        return text;
      }

      // 스페이스로 구분된 여러 단어를 각각 하이라이팅
      const keywords = keyword.split(/\s+/).filter(k => k.length > 0);

      let result = text;
      keywords.forEach(word => {
        // 정규식 특수문자 이스케이프 처리
        const escapedWord = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`(${escapedWord})`, 'gi');
        result = result.replace(regex, '<span class="result-keyword">$1</span>');
      });

      return result;
    },

    formatDate(dateString) {
      if (!dateString) return '';

      try {
        // 20210506132727 형식의 문자열을 파싱
        if (dateString.length === 14) {
          const year = dateString.substring(0, 4);
          const month = dateString.substring(4, 6);
          const day = dateString.substring(6, 8);
          return `${year}-${month}-${day}`;
        }

        // 기존 방식으로 파싱 시도
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
          return date.toISOString().split('T')[0];
        }

        return dateString;
      } catch (e) {
        return dateString;
      }
    },

    formatTimestamp(timestamp) {
      if (!timestamp) return '';

      try {
        // 20210506132727 형식의 문자열을 파싱
        if (timestamp.length === 14) {
          const year = timestamp.substring(0, 4);
          const month = timestamp.substring(4, 6);
          const day = timestamp.substring(6, 8);
          const hour = timestamp.substring(8, 10);
          const minute = timestamp.substring(10, 12);
          return `${year}-${month}-${day} ${hour}:${minute}`;
        }

        // 기존 방식으로 파싱 시도
        const date = new Date(timestamp);
        if (!isNaN(date.getTime())) {
          return date.toLocaleString('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
          });
        }

        return timestamp;
      } catch (e) {
        return timestamp;
      }
    },

    // URL 생성 로직 - LINK_URL을 디코딩하여 사용
    generateUrl(item) {
      if (!item || !item.LINK_URL) return '#';

      return this.decodeUnicodeUrl(item.LINK_URL);
    },

    // URL 유니코드 디코딩 처리
    decodeUnicodeUrl(url) {
      if (!url) return '#';

      try {
        // 유니코드 이스케이프 시퀀스 디코딩 (\u003d → =, \u0026 → &)
        return url.replace(/\\u[\dA-F]{4}/gi, (match) =>
            String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16))
        );
      } catch (error) {
        return '#';
      }
    },

    // 탭을 전체(ALL)로 리셋하는 메서드
    resetToAllTab() {
      this.activeMenu = 'ALL';
      this.currentPage = 1;
      // 부모 컴포넌트에 탭 변경 알림
      this.emitTabChange();
    },

    // API 응답에서 태그 추출
    extractTags(item) {
      // 여러 가능한 태그 필드 확인
      const tagSources = [
        item.TAGS_NM,
        item.TAG_LIST,
        item.KEYWORDS,
        item.HASH_TAGS
      ];

      for (const source of tagSources) {
        if (source && typeof source === 'string') {
          return source.split(',').map(tag => tag.trim()).filter(tag => tag);
        }
      }

      return [];
    },

    // 태그 클릭 시 해당 키워드로 검색
    searchByTag(tag) {
      // 부모 컴포넌트에 태그 검색 요청
      this.$emit('tag-search', tag);
    },

    // 이미지 로드 에러 처리
    handleImageError(item) {
      // 초기값으로 설정했으므로 직접 할당 가능
      item.imageError = true;
      // 강제로 리렌더링 트리거
      this.$forceUpdate();
    },

    // 이미지 로드 성공 처리
    handleImageLoad(item) {
      // 이미지가 성공적으로 로드되면 에러 상태 제거
      item.imageError = false;
      this.$forceUpdate();
    }
  },

  mounted() {
    // 첫 번째 센터를 기본 선택으로 설정
    if (this.centerList && this.centerList.length > 0) {
      this.activeCenter = this.centerList[0].id;
    }
  },

  watch: {
    // 검색 결과 변경 감지
    searchResults: {
      handler(newResults) {
        if (newResults && Object.keys(newResults).length > 0) {
          this.updateSearchCounts(newResults);
        }
      },
      deep: true,
      immediate: true
    },
  }
};
</script>



// WEBPACK FOOTER //
// SearchContent.vue?727f163a